// Stable device id persisted in localStorage.
// Not bulletproof (user can clear storage) but stable for regular usage.
export function getDeviceId() {
  try {
    let id = localStorage.getItem("nightingale_device_id");
    if (!id) {
      const rnd = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
      id = `dev_${rnd}`;
      localStorage.setItem("nightingale_device_id", id);
    }
    return id;
  } catch {
    return "dev_fallback";
  }
}
